module.exports = __webpack_public_path__ + "static/media/checkout-cartInBag.d9828605.png";